import { Box, BoxProps, Text } from "@vinomofo/components";

import { StaticImage } from "gatsby-plugin-image";
import priceDrop from "../../resources/images/price-drop.svg";

export const PriceDrop = (props: BoxProps): JSX.Element => {
  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      alignSelf="center"
      zIndex="1"
      {...props}
    >
      <Box
        boxShadow="0 2px 4px 0 rgba(0,0,0,0.25)"
        padding="2px 5px"
        backgroundColor="white"
        borderRadius="2px"
        marginBottom="5px"
      >
        <Text fontFamily="heading" fontWeight="bold" fontSize="8px">
          PRICE DROP
        </Text>
      </Box>
      <img src={priceDrop} width={22} height={22} alt="" />
    </Box>
  );
};
